import React from 'react';

import { Localize } from "./localize.js";

class UserMenu extends React.Component {
  constructor(props) {
    super(props)
  }

  componentDidMount() {
  }

  componentWillUnmount() {
  }

  render() {
    var ret = null;
    if (this.props.user && this.props.user.isauthenticated) {
      //we know it's an email, if it's not, it's not a problem
      var username = this.props.user.name;
      // parent node <li class="nav-item dropdown">

      ret = (
          <div onClick={(e) => this.props.toggle(e, "UserMenu")}>
            <a className="nav-link ddropdown-toggle" data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false">
              <div style={{ fontFamily: "Roboto Condensed", whiteSpace: "nowrap", fontSize: "14px", lineHeight: 1.1 }}>{Localize.L("Ciao")} {username}</div>
              <div><i className="fas fa-user-cog"></i> {Localize.L("I tuoi ordini")}</div>
            </a>
            <div className="dropdown-menu" style={{ fontSize: '100%', display: this.props.show ? "block" : "none" }}>
              <a className="dropdown-item" href="/user/ordini"><i className="far fa-file-alt fa-fw"></i> {Localize.L("I tuoi ordini")}</a>
              <div className="dropdown-divider" />
              <a className="dropdown-item" href="/user/password"><i className="fas fa-key fa-fw"></i> {Localize.L("Modifica password")}</a>
              <div className="dropdown-divider" />
              <a className="dropdown-item" href="/logout"><i className="fas fa-sign-out-alt fa-fw"></i> {Localize.L("Esci")}</a>
            </div>
          </div>
      );
    }

    return ret;
  }
}

export { UserMenu }
